import styled from 'styled-components';
import { BodyRegularS, CaptionRegularM, HeadingExtraBoldS } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';
import {
  MAPPED_DEPARTMENT_CELL_WIDTH,
  NAME_CELL_WIDTH,
  PARTICIPANTS_CELL_WIDTH,
  TYPE_CELL_WIDTH,
} from '../ReportsSetupTableHeader/ReportsSetupTableHeader.styles';
import AssigmentIcon from '@/assets/icons/add_asigment.svg?react';
import AddIcon from '@/assets/icons/addParticipantIcon.svg?react';
import PencilIcon from '@/assets/icons/pencil.svg?react';
import TrashIcon from '@/assets/icons/trashCanIcon.svg?react';

export const ResizeCont = styled.div`
  cursor: pointer;
  height: 48px;
  width: 48px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 16px;

  svg {
    width: 7.5px;
    height: 14.92px;
  }
  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.centy} 0 0;
  `};
`;

export const TileCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: fit-content;
  ${({ theme }: IThemeProvider) => `
    padding: 6px ${theme.layout.spacing.centy};
  `}

  :hover {
    ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.primary[10]};
    `}
    #ActionIcons {
      display: inherit;
    }
  }
`;

export const LeftDetailsCont = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const Name = styled(HeadingExtraBoldS)`
  font-size: 18px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: ${NAME_CELL_WIDTH};
  justify-self: flex-start;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}

  &:hover {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
`;

interface IType {
  backgroundColor: string;
  borderColor: string;
  theme: ITheme;
  marginRight: string;
}

export const TypeCont = styled.div<IType>`
  display: flex;
  align-items: center;
  justify-items: center;
  padding: 5px 12px;
  width: fit-content;
  ${({ backgroundColor, borderColor, theme }: IType) => `
    background: ${backgroundColor};
    border: 1px solid ${borderColor};
    border-radius: ${theme.layout.spacing.nano};
    height: ${theme.layout.spacing.decy};
  `}
`;

export const Type = styled(CaptionRegularM)`
  text-transform: uppercase;
`;

export const TypeCell = styled.div`
  width: ${TYPE_CELL_WIDTH};
`;

export const ParticipantsCell = styled.div`
  width: ${PARTICIPANTS_CELL_WIDTH};
`;

export const ParticipantsCount = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const MappedDepartment = styled(BodyRegularS)`
  width: ${MAPPED_DEPARTMENT_CELL_WIDTH};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}

  &:hover {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }
`;

export const AddParticipantIcon = styled(AddIcon)`
  height: 20px;
  justify-self: flex-end;
  margin: auto 16px auto auto;
  cursor: pointer;
`;

export const AddTeamReportIcon = styled(AssigmentIcon)`
  height: 20px;
  justify-self: flex-end;
  margin: auto 16px auto auto;
  cursor: pointer;
`;

export const DeleteReportIcon = styled(TrashIcon)`
  width: 16px;
  height: 20px;
  justify-self: flex-end;
  margin: auto 16px auto auto;
  cursor: pointer;
`;

export const EditReportIcon = styled(PencilIcon)`
  height: 20px;
  justify-self: flex-end;
  margin: auto 16px auto auto;
  cursor: pointer;
`;

export const ExecutiveTileButtonsCont = styled.div`
  display: flex;
  justify-self: flex-end;
  margin: auto 4px auto auto;
`;

export const StatisticsCont = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IActionIconsCont {
  isVisible?: boolean;
  theme: ITheme;
}
export const ActionIconsCont = styled.div<IActionIconsCont>`
  position: absolute;
  right: 0;
  display: none;
  ${({ isVisible }: IActionIconsCont) => `
    ${isVisible && 'display: inherit;'}
  `}
`;
